import React from 'react';
import Header from 'layout/partials/Header.jsx';
import Footer from 'layout/partials/Footer.jsx';
import { User } from 'api';
import cookie from 'react-cookie';
import classnames from 'classnames';
window.CALL_API = false;

class MasterLayout extends React.Component {
  handleMouseClick() {
    if (cookie.load('accessToken') && window.CALL_API == false ) {
      window.CALL_API = true;
      setTimeout(() => {
        window.CALL_API = false;
      }, 180000);
      User.actions.updateSession.request();
    }
  }
  render() {
    const childrenWithProps = React.Children.map(this.props.children, (child) => React.cloneElement(child, {}));
    return (
      <div className="wrapper-container">
        <Header routerName={this.props.routerName}/>
        <main
          className={classnames('main-container', {
            'tc': this.props.routerName == 'congDanTraCuu' || this.props.routerName === 'giamSatTraCuu',
            'no-bg': this.props.type == 'ketQua'
          })}
          onMouseUp={this.handleMouseClick.bind(this)} >
          {childrenWithProps}
        </main>
        <Footer/>
      </div>
    );
  }
}

MasterLayout.defaultProps = {
  type: ''
}

export default MasterLayout;



// WEBPACK FOOTER //
// ./src/components/layout/master/MasterLayout.jsx